import { Card, CardContent, Divider, Stack, Typography } from '@mui/material';

/**
 * Outlined card with an overline title, optional description and a stacked
 * body — the standard left-column section in our two-column form layout.
 *
 * Use it instead of `<Card><CardHeader title=...><CardContent>...` blocks
 * so the visual rhythm (title weight, divider spacing, inner stack gap)
 * stays consistent across every form.
 */
const FormCard = ({ title, description, children }) => (
  <Card variant="outlined">
    <CardContent>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ fontWeight: 600, letterSpacing: 0.8 }}
      >
        {title}
      </Typography>
      {description && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {description}
        </Typography>
      )}
      <Divider sx={{ my: 1.5 }} />
      <Stack spacing={2}>{children}</Stack>
    </CardContent>
  </Card>
);

export default FormCard;
